var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attachments"},_vm._l((_vm.documents),function(document){return _c('div',{key:document.id},[_c('post-attachment',{staticClass:"attachment",attrs:{"document":document}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }